import React from 'react';
import { BookOpen, FileText, Scale } from 'lucide-react';
import { LawData } from '../../types';
import { useTheme } from './ThemeContext';

const LawCard: React.FC<LawData> = ({ title, description, relevantSections, keyProvisions }) => {
  const { theme } = useTheme();

  return (
    <div className={`rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow duration-300 ${theme === 'dark'
        ? 'bg-[#1e2128] text-gray-200'
        : 'bg-white text-gray-900'
      }`}>
      <h3 className={`text-lg font-semibold mb-2 flex items-center ${theme === 'dark' ? 'text-gray-100' : 'text-[#302A2A]'
        }`}>
        <Scale size={20} className={`mr-2 ${theme === 'dark' ? 'text-blue-400' : 'text-gray-700'}`} />
        {title}
      </h3>
      <p className={`mb-3 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>{description}</p>
      <div className={`flex items-center text-sm mb-2 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
        <BookOpen size={16} className="mr-2" />
        <span>Relevant Sections: {relevantSections}</span>
      </div>
      <div className={`flex items-center text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
        <FileText size={16} className="mr-2" />
        <span>Key Provisions: {keyProvisions}</span>
      </div>
    </div>
  );
};

export default LawCard;